import { useEffect, useRef } from "react";

/**
 * Custom hook que detecta la transición `false → true` de una flag
 * (típicamente "todos los RFCs ya tienen proveedor asignado") y dispara
 * un callback de navegación una sola vez.
 *
 * Por qué no es un simple `useEffect`: si el usuario llega a la pantalla
 * con la asignación ya completa (volvió desde el detalle), NO queremos
 * redirigir · solo cuando la transición ocurre durante esta sesión.
 *
 * Capturamos el primer snapshot real (cuando `ready === true`) y de ahí
 * en adelante comparamos contra el valor previo para detectar el flanco
 * de subida.
 */
export function useAutoRedirectCuandoAsignados(
  todosAsignados: boolean,
  ready: boolean,
  onAsignacionCompletada: () => void
) {
  const inicializado = useRef(false);
  const previo = useRef(false);
  useEffect(() => {
    if (!ready) return;
    if (!inicializado.current) {
      previo.current = todosAsignados;
      inicializado.current = true;
      return;
    }
    if (!previo.current && todosAsignados) {
      onAsignacionCompletada();
    }
    previo.current = todosAsignados;
  }, [todosAsignados, ready, onAsignacionCompletada]);
}
